import I18n from 'I18n';
import { useSkillLabels } from 'skills-lib/hooks/useSkillLabels';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const SkillLabels = ({
  values
}) => {
  const {
    labels
  } = useSkillLabels(values);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: I18n.formatList(labels)
  });
};